'use client';
import { useCallback } from 'react';

const SESSION_STORAGE_KEY = 'parentPaths';

function loadFromSessionStorage(): string[] {
  if (typeof window === 'undefined') return [];

  try {
    const data: unknown = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY) ?? '[]');
    return Array.isArray(data) ? data.filter((path): path is string => typeof path === 'string') : [];
  } catch {
    return [];
  }
}

function saveToSessionStorage(parentPaths: string[]) {
  if (parentPaths.length === 0) {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } else {
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(parentPaths));
  }
}

export function useParentHistoryParams() {
  const pushParentPath = useCallback((parentPath: string) => {
    // 화면 전환으로 호출 컴포넌트가 언마운트되기 전에 복귀 주소를 저장한다.
    saveToSessionStorage([...loadFromSessionStorage(), parentPath]);
  }, []);

  const popParentPath = useCallback(() => {
    // 다른 화면/훅에서 저장한 최신 스택을 읽어 오래된 로컬 상태로 덮어쓰지 않는다.
    const parentPaths = loadFromSessionStorage();
    const lastPath = parentPaths.pop();
    saveToSessionStorage(parentPaths);
    return lastPath;
  }, []);

  return { pushParentPath, popParentPath };
}
